var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',{staticClass:"style-description-small version-footer",on:{"click":_vm.tapVersion}},[_vm._v("\n    v"+_vm._s(_vm.version)+" ("+_vm._s(_vm.nativeVersion)+", "+_vm._s(_vm.environment)+")\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }